import React, { useState, useEffect, Fragment, Text } from "react";
import { NavLink } from "react-router-dom";
import { useGetAllCompanies, deleteCompany } from "../Utils/Company";
import { useGetAllUsers } from "../Utils/User";
import { useGetAllFleets } from "../Utils/Fleet";
import Table from "../Base/Table";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

/**
 * Company Table Component
 */
const CompanyTable = ({ title, limit }) => {
  const { loading: loadingCompanies, companies } = useGetAllCompanies();

  const companyCols = [
    {
      Header: "Name",
      accessor: "name",
      minWidth: 200,
      headerClassName: "left",
      Cell: props => {
        // eslint-disable-next-line react/prop-types
        const { original } = props;
        return <NavLink to={`/company/${original.cid}`}>{original.name}</NavLink>;
      }
    },
    {
      Header: "Fleets",
      sortable: false,
      className: "center",
      Cell: props => {
        // eslint-disable-next-line react/prop-types
        const { original } = props;
        const { loading: loadingFleets, fleets } = useGetAllFleets(original.cid);
        if (fleets) {
          return <p className="field-value">{fleets.length}</p>;
        } else {
          return <p className="field-value">--</p>;
        }
      }
    },
    {
      Header: "Drivers",
      sortable: false,
      className: "center",
      Cell: props => {
        // eslint-disable-next-line react/prop-types
        const { original } = props;
        const { users: allCompanyDrivers, loading: loadingAllCompanyDrivers } = useGetAllUsers(
          original.cid,
          null,
          "driver"
        );
        if (allCompanyDrivers) {
          return <p className="field-value">{allCompanyDrivers.length}</p>;
        } else {
          return <p className="field-value">--</p>;
        }
      }
    },
    {
      Header: "Avg. Energy",
      sortable: false,
      className: "center",
      Cell: props => {
        // eslint-disable-next-line react/prop-types
        const { original } = props;
        const { users: allCompanyDrivers, loading: loadingAllCompanyDrivers } = useGetAllUsers(
          original.cid,
          null,
          "driver"
        );
        if (allCompanyDrivers) {
          const values = allCompanyDrivers.map(d => d.stats.energyLevel);
          var sum = 0;
          var avg = 0;
          values.forEach(value => {
            if (value > 0) sum += value;
          });
          avg = sum > 0 ? Math.round(sum / values.length) : 0;

          return <p className="field-value">{avg}</p>;
        } else {
          return <p className="field-value">--</p>;
        }
      }
    },
    {
      Header: "",
      sortable: false,
      className: "center",
      Cell: props => {
        // eslint-disable-next-line react/prop-types
        const { original } = props;
        return (
          <button
            type="button"
            onClick={() => {
              confirmAlert({
                title: "Confirm Deletion",
                message: "Are you sure you want to delete this company?",
                buttons: [
                  {
                    label: "Yes",
                    onClick: () => deleteCompany(original.cid)
                  },
                  {
                    label: "No"
                  }
                ]
              });
            }}
          >
            Delete
          </button>
        );
      }
    }
  ];

  return (
    <Fragment>
      {title && <h2>{title}</h2>}
      <Table
        data={loadingCompanies ? [] : companies}
        columns={companyCols}
        pageSize={!loadingCompanies && (limit <= companies.length ? limit : companies.length)}
      />
    </Fragment>
  );
};

export default CompanyTable;
